<template>
  <div>
    <div v-if="page.store_details.length === 0">Store not found.</div>
    <div v-if="page.store_details.length >= 1">
      <h2>
        <span class="text-darkgray">{{ page.store_details[0].region }}</span>
        <i class="fas fa-angle-right text-pod" style="margin:0 20px"
        ></i>{{ page.store_details[0].store }}
      </h2>
      <b-row>
        <b-col>
          <b-card title="LiveStore Store Agent" sub-title="Store information relevant to keeping LiveStore healthy.">
            <b-list-group flush>
              <fact metric="CPU Architecture">{{ lastPing.is_64bit ? '64' : '32' }}-bit</fact>
              <fact metric="LiveStore agent version" :value="currentVersion"/>
              <fact metric="Server last restarted" :value="lastRestarted"/>
              <fact metric="Last heard from store" :value="localLastHeardFromPretty"/>
          </b-list-group>
          <action-button
            v-if="localLastHeardFromDelta.asMinutes() < 60"
            variant="success"
            size="lg"
            buttonClass="wide"
            buttonText="Mark store as healthy"
            busyText="Resolving store state"
            actionName="podMarkStoreAsHealthy"
            :parameters="{ location }"
            @done="allAsResolved" />
          </b-card>
        </b-col>
        <b-col>
          <store-health-check :recent="page.recent" :lastPing="lastPing"/>
        </b-col>
      </b-row>
      <b-row v-if="page.recent.length > 0" style="margin-top:30px">
        <b-col>
          <h2>Recent Reports</h2>
          <recent-grouped :items="page.recent"/>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import * as moment from 'moment'
import Fact from './Fact.vue'
import RecentGrouped from './RecentGrouped.vue'
import StoreHealthCheck from './StoreHealthCheck.vue'
import ActionButton from '@/components/ActionButton.vue'

export default {
  props: ['page', 'location'],
  components: { Fact, RecentGrouped, StoreHealthCheck, ActionButton },
  data () {
    return {
      busy: false
    }
  },
  computed: {
    lastPing() {
      return this.page.last_ping[0];
    },
    currentVersion() {
      let version = this.lastPing.component_version;
      if (version === '99.99.99.99') {
        return 'v8 (pre-8.3.97)';
      }
      return `${version} (build #${this.lastPing.build_version})`;
    },
    lastRestarted() {
      return moment().add(0-this.lastPing.uptime, 'seconds').format('D/MM/YY hh:mm A')
    },
    localLastHeardFrom() {
      return moment(this.lastPing.raised_at_utc.value).add(this.lastPing.gmt_offset, 'minutes');
    },
    localLastHeardFromDelta() {
      return moment.duration(moment().diff(this.localLastHeardFrom))
    },
    localLastHeardFromPretty() {
      return this.localLastHeardFrom.format('D/MM/YY hh:mm A')
    }
  },
  methods: {
    allAsResolved () {
      this.page.recent = this.page.recent.map(r => ({ ...r, is_resolved: true }))
    }
  }
}
</script>

<style>
.wide {
  width: 100%;
}
</style>